// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-ChecksList__wrapper","points":"c-ChecksList__points","checkItem":"c-ChecksList__checkItem","inner":"c-ChecksList__inner","bold":"c-ChecksList__bold","labelBig":"c-ChecksList__labelBig","labelSmall":"c-ChecksList__labelSmall","block":"c-ChecksList__block","detail":"c-ChecksList__detail"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ChecksList/ChecksList.scss
// module id = 1135
// module chunks = 0